import { render, staticRenderFns } from "./AreaEmbargadaParana.vue?vue&type=template&id=70b4e49a&scoped=true&lang=pug"
import script from "./AreaEmbargadaParana.vue?vue&type=script&lang=js"
export * from "./AreaEmbargadaParana.vue?vue&type=script&lang=js"
import style0 from "./AreaEmbargadaParana.vue?vue&type=style&index=0&id=70b4e49a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b4e49a",
  null
  
)

export default component.exports